export default function Solution() {
  const pillars = [
    {
      icon: 'ri-brain-line',
      number: '01',
      label: 'КИТ №1',
      title: 'Стратегия',
      subtitle: 'Мозг системы',
      description: 'Понимание кого, где и как мы привлекаем',
      accent: true,
      items: [
        { icon: 'ri-map-pin-user-line', title: 'CJM (Customer Journey Map)', text: 'Путь клиента от осознания потребности до покупки' },
        { icon: 'ri-medal-line', title: 'УТП и Позиционирование', text: 'Чем мы лучше конкурентов и почему купить нужно именно у нас' },
        { icon: 'ri-money-dollar-circle-line', title: 'Финансовые цели', text: 'Чёткое понимание, сколько лидов и по какой цене нужно получить' },
      ],
    },
    {
      icon: 'ri-tools-line',
      number: '02',
      label: 'КИТ №2',
      title: 'Инструменты',
      subtitle: 'Руки системы',
      description: 'Техническая реализация стратегии',
      accent: false,
      items: [
        { icon: 'ri-advertisement-line', title: 'Рекламные каналы', text: 'Яндекс.Директ, Google Ads, ВКонтакте, таргет в соцсетях' },
        { icon: 'ri-robot-2-line', title: 'Автоматизация', text: 'Сервисы, которые исключают человеческий фактор и работают 24/7' },
        { icon: 'ri-line-chart-line', title: 'Сквозная аналитика', text: 'Связывает клики с деньгами в кассе — видите каждый рубль' },
      ],
    },
    {
      icon: 'ri-team-line',
      number: '03',
      label: 'КИТ №3',
      title: 'Команда',
      subtitle: 'Сердце системы',
      description: 'Люди, которые управляют инструментами',
      accent: true,
      items: [
        { icon: 'ri-focus-3-line', title: 'Чёткая функция и KPI', text: 'Каждый сотрудник знает свою зону ответственности и цели' },
        { icon: 'ri-file-list-3-line', title: 'Понятные регламенты', text: 'Инструкции и процессы, которые обеспечивают качество' },
        { icon: 'ri-rocket-line', title: 'Мотивация на результат', text: 'Фокус на достижении целей, а не на имитации процесса' },
      ],
    },
  ];

  const results = [
    { icon: 'ri-eye-line', title: 'Контроль и прозрачность', text: 'Вы всегда знаете, сколько прибыли приносит каждый рубль, вложенный в трафик.' },
    { icon: 'ri-team-line', title: 'Лояльность и сообщество', text: 'Соцсети перестают быть «визиткой» и становятся инструментом повторных продаж.' },
    { icon: 'ri-time-line', title: 'Экономия времени', text: 'Автоматизация освобождает ваше время для стратегического управления.' },
    { icon: 'ri-trophy-line', title: 'Доминирование на рынке', text: 'Прогнозируемый рост оборота и вывод товаров в топ поисковой выдачи.' },
  ];

  return (
    <section className="py-28 bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 80% 20%, rgba(197,168,128,0.05) 0%, transparent 50%), radial-gradient(circle at 20% 80%, rgba(26,43,76,0.04) 0%, transparent 50%)' }}></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* ── Section Header ── */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-10 h-px bg-[#C5A880]"></div>
            <span className="text-[#C5A880] text-sm font-semibold tracking-[0.2em] uppercase font-['Montserrat']">Методология</span>
            <div className="w-10 h-px bg-[#C5A880]"></div>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A2B4C] mb-6 font-['Playfair_Display'] leading-tight">
            Что такое системный маркетинг?
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto font-['Montserrat'] leading-relaxed">
            Ваш ключ к стабильному росту и предсказуемым продажам
          </p>
        </div>

        {/* ── Two-column intro ── */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {/* Problem card */}
          <div className="relative bg-[#1A2B4C] rounded-2xl p-8 md:p-10 overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 rounded-full border border-white/5 -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 rounded-full border border-[#C5A880]/10 translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 flex items-center justify-center bg-red-500/20 border border-red-400/30 rounded-xl mb-6">
                <i className="ri-alert-line text-xl text-red-400"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 font-['Playfair_Display'] leading-snug">
                Маркетинговый хаос —<br />враг вашей прибыли
              </h3>
              <p className="text-white/60 leading-relaxed font-['Montserrat'] text-sm">
                Большинство компаний живут в состоянии <span className="text-white/90 font-semibold">«маркетингового хаоса»</span>: точечные запуски рекламы, смена подрядчиков, отсутствие понимания, какой рубль принёс прибыль, а какой был слит впустую.
              </p>
            </div>
          </div>

          {/* Solution card */}
          <div className="relative bg-[#F8F9FA] border border-[#C5A880]/20 rounded-2xl p-8 md:p-10 overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C5A880] to-transparent opacity-50"></div>
            <div className="w-12 h-12 flex items-center justify-center bg-[#C5A880]/15 border border-[#C5A880]/30 rounded-xl mb-6">
              <i className="ri-settings-3-line text-xl text-[#C5A880]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2B4C] mb-4 font-['Playfair_Display'] leading-snug">
              Системный маркетинг —<br />противоположность хаосу
            </h3>
            <p className="text-gray-600 leading-relaxed font-['Montserrat'] text-sm mb-4">
              Это подход, при котором маркетинг рассматривается <strong className="text-[#1A2B4C]">не как набор разрозненных действий</strong>, а как{' '}
              <strong className="text-[#C5A880]">единый организм, работающий на предсказуемый финансовый результат</strong>.
            </p>
            <p className="text-gray-500 leading-relaxed font-['Montserrat'] text-sm">
              Это фундамент, благодаря которому клики превращаются в реальных, лояльных клиентов, а каждый вложенный рубль приносит измеримую прибыль.
            </p>
          </div>
        </div>

        {/* ── Three Pillars Header ── */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#C5A880]/50"></div>
            <span className="text-[#C5A880] text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">Три кита системного маркетинга</span>
            <div className="w-8 h-px bg-[#C5A880]/50"></div>
          </div>
          <h3 className="text-3xl md:text-4xl font-bold text-[#1A2B4C] font-['Playfair_Display']">
            Единство трёх элементов
          </h3>
        </div>

        {/* ── Three Pillars Grid ── */}
        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {pillars.map((pillar) => (
            <div
              key={pillar.number}
              className="group bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl hover:border-[#C5A880]/40 transition-all duration-300 relative overflow-hidden"
            >
              {/* Top gold line on hover */}
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#C5A880] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Ghost number */}
              <div className="absolute top-4 right-6 text-6xl font-bold text-[#1A2B4C]/5 font-['Playfair_Display'] select-none leading-none">
                {pillar.number}
              </div>

              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 ${pillar.accent ? 'bg-[#C5A880]/15 border border-[#C5A880]/30' : 'bg-[#1A2B4C]/10 border border-[#1A2B4C]/20'}`}>
                <i className={`${pillar.icon} text-2xl ${pillar.accent ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}></i>
              </div>

              {/* Badge */}
              <div className="inline-block px-3 py-1 bg-[#F8F9FA] text-[#1A2B4C]/60 rounded-full text-xs font-semibold mb-3 font-['Montserrat'] tracking-wider">
                {pillar.label}
              </div>

              <h4 className="text-2xl font-bold text-[#1A2B4C] mb-1 font-['Playfair_Display']">{pillar.title}</h4>
              <p className="text-[#C5A880] text-sm font-semibold mb-3 font-['Montserrat']">{pillar.subtitle}</p>
              <p className="text-gray-500 text-sm mb-6 font-['Montserrat']">{pillar.description}</p>

              <div className="space-y-3">
                {pillar.items.map((item, i) => (
                  <div key={i} className="flex items-start gap-3 bg-[#F8F9FA] rounded-xl p-3.5 border border-gray-100">
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-base ${pillar.accent ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}></i>
                    </div>
                    <div>
                      <strong className="text-[#1A2B4C] text-xs block mb-0.5 font-['Montserrat']">{item.title}</strong>
                      <p className="text-gray-500 text-xs font-['Montserrat'] leading-relaxed">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* ── Results Section ── */}
        <div className="relative bg-[#1A2B4C] rounded-2xl p-10 md:p-16 overflow-hidden">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-80 h-80 rounded-full border border-white/5 translate-x-1/3 -translate-y-1/3 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-56 h-56 rounded-full border border-[#C5A880]/10 -translate-x-1/3 translate-y-1/3 pointer-events-none"></div>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C5A880]/60 to-transparent"></div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-3 mb-5">
                <div className="w-8 h-px bg-[#C5A880]/50"></div>
                <span className="text-[#C5A880] text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">Результаты после внедрения</span>
                <div className="w-8 h-px bg-[#C5A880]/50"></div>
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 font-['Playfair_Display']">
                Ваш успех — это не случайность
              </h3>
              <p className="text-white/50 max-w-2xl mx-auto font-['Montserrat'] text-sm leading-relaxed">
                Это результат умных алгоритмов и безупречной стратегии. Мы строим для вас мощный, автономный отдел маркетинга.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {results.map((r, i) => (
                <div key={i} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 hover:border-[#C5A880]/30 transition-all duration-300">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#C5A880]/20 border border-[#C5A880]/30 rounded-xl flex-shrink-0">
                    <i className={`${r.icon} text-lg text-[#C5A880]`}></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1 font-['Montserrat'] text-sm">{r.title}</h4>
                    <p className="text-white/50 text-sm font-['Montserrat'] leading-relaxed">{r.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
